import { Component, OnInit, Inject, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-anonymous-user-layout',
  templateUrl: './app-AnonymousUserLayout.component.html',
  styleUrls: ['./app-AnonymousUserLayout.component.css']
})
export class AppAnonymousUserLayoutComponent {


  constructor() {
  }


}
